export default __webpack_public_path__ + "static/media/xsplit-logo-vector.cf4ccdf2.svg";